<template>
  <svg
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    aria-label="Logo Crystal"
    role="img"
  >
    <!-- Capa 1: Hexágono exterior (estático, ancla visual) -->
    <polygon points="32,6 50,20 50,44 32,58 14,44 14,20" fill="#0288D1" />

    <!-- Capa 2: Hexágono medio (rota — Freezing Field) -->
    <polygon class="crystal-inner" points="32,14 44,24 44,40 32,50 20,40 20,24" fill="#29B6F6" opacity=".7" />

    <!-- Capa 3: Hexágono núcleo (pulsa — aura de hielo) -->
    <polygon class="crystal-core" points="32,22 38,28 38,36 32,42 26,36 26,28" fill="#81D4FA" opacity=".6" />
  </svg>
</template>

<script>
export default {
  name: 'CrystalLogo',
  props: {
    size: {
      type: [Number, String],
      default: 48,
    },
  },
};
</script>

<style scoped>
@keyframes crystal-rotate {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
@keyframes crystal-pulse {
  0%, 100% { opacity: .6; }
  50%      { opacity: .9; }
}

.crystal-inner { transform-origin: 32px 32px; animation: crystal-rotate 12s linear infinite; }
.crystal-core  { animation: crystal-pulse 2s ease-in-out infinite; }

@media (prefers-reduced-motion: reduce) {
  .crystal-inner, .crystal-core {
    animation: none;
  }
}
</style>
